import { render, staticRenderFns } from "./NewFooter.vue?vue&type=template&id=ab5e6d60&scoped=true&"
import script from "./NewFooter.vue?vue&type=script&lang=js&"
export * from "./NewFooter.vue?vue&type=script&lang=js&"
import style0 from "./NewFooter.vue?vue&type=style&index=0&id=ab5e6d60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5e6d60",
  null
  
)

export default component.exports